import React, { useState } from 'react';
import {
  Box,
  Button,
  Flex,
  Icon,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { ArrowLeft, FunnelSimple } from 'phosphor-react';
import { Facet } from './facet';
import { FacetOptionList, FacetSearch } from './FacetOptionList';

interface FacetMenuProps {
  facets: Facet[];
}

export const FacetMenu = ({ facets }: FacetMenuProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [search, setSearch] = useState('');
  const [activeKey, setActiveKey] = useState<string | null>(null);
  const active = facets.find((facet) => facet.key === activeKey);
  const visible = facets.filter((facet) =>
    facet.label.toLowerCase().includes(search.trim().toLowerCase())
  );

  const handleClose = () => {
    onClose();
    setActiveKey(null);
    setSearch('');
  };

  if (facets.length === 0) return null;

  return (
    <Popover isOpen={isOpen} onOpen={onOpen} onClose={handleClose} placement="bottom-start">
      <PopoverTrigger>
        <Button
          variant="secondary"
          size="sm"
          leftIcon={<FunnelSimple size={14} />}
          aria-label="Filtros"
        >
          Filtros
        </Button>
      </PopoverTrigger>
      <PopoverContent w="288px" p={0} overflow="hidden">
        <PopoverBody p={0}>
          {active ? (
            <>
              <Flex
                as="button"
                type="button"
                align="center"
                gap="8px"
                px="12px"
                py="12px"
                w="full"
                cursor="pointer"
                color="content.subtle"
                _hover={{ color: 'content.strong' }}
                onClick={() => setActiveKey(null)}
              >
                <Icon as={ArrowLeft} w="14px" h="14px" />
                <Text fontSize="13px">{active.label}</Text>
              </Flex>
              <FacetOptionList
                facet={active}
                onApply={(values) => {
                  active.apply(values);
                  handleClose();
                }}
              />
            </>
          ) : (
            <>
              <FacetSearch label="filtros" value={search} onChange={setSearch} />
              <Box p="4px">
                <Text px="12px" pt="8px" pb="4px" fontSize="12px" color="content.faint">
                  Filtrar por
                </Text>
                {visible.map((facet) => (
                  <Flex
                    as="button"
                    type="button"
                    key={facet.key}
                    w="full"
                    h="36px"
                    align="center"
                    gap="8px"
                    px="12px"
                    borderRadius="6px"
                    cursor="pointer"
                    textAlign="left"
                    _hover={{ bg: 'surface.selected' }}
                    onClick={() => setActiveKey(facet.key)}
                  >
                    <Icon as={facet.icon} w="14px" h="14px" color="content.subtle" />
                    <Text fontSize="13px" color="content.strong" noOfLines={1}>
                      {facet.label}
                    </Text>
                  </Flex>
                ))}
                {visible.length === 0 && (
                  <Text px="12px" py="8px" fontSize="13px" color="content.subtle">
                    Nenhum filtro encontrado.
                  </Text>
                )}
              </Box>
            </>
          )}
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
